// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2849":"fd7ff96c","4433":"ea5400ae","8986":"fd7ff96c","9650":"fd7ff96c"}[chunkId] + ".chunk.css";
};